const BASE_URL = import.meta.env.VITE_API_URL ?? "";

export const URL_access = `${BASE_URL}/auth/login`;
export const URL_REGISTER = `${BASE_URL}/auth/register`;
export const URL_Autor = `${BASE_URL}/autores`;
export const URL_Books_Register = `${BASE_URL}/livros`;
export const URL_BookFavoriting = `${BASE_URL}/favoritos`;
export const URL_Books_Category = `${BASE_URL}/categorias`;
export const URL_documents = `${BASE_URL}/documentos`;
export const URL_ALL_USERS = `${BASE_URL}/usuarios`;
